const facettedSearchWidget = require('../../_utilities/facettedsearchwidget');

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'studios',
    component: 'studios',
    reducer: reducer(),
  })
    .then(facettedSearchWidget('studios'))
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/studios/studios.js